import { useTranslation } from "react-i18next";
import { COMISSION_RULES, formatTurnoverForDisplay } from "./Rule";
import i18next from "i18next";

const RuleTable = ({ special }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`referral.${key}`);

  return (
    <section className="md:max-w-[500px] text-light-text">
      <section
        className={`${
          special && "bg-main-color"
        } w-full grid grid-cols-3 text-xs font-bold border border-light-text p-[5px]`}
      >
        <p className="mb-0 text-start">{i18n("Rule.commission.tr1")}</p>
        <p className="mb-0 text-start">{i18n("Rule.commission.tr2")}</p>
        <p className="mb-0 text-end">{i18n("Rule.commission.tr3")}</p>
      </section>
      {COMISSION_RULES.map((rule, index) => {
        return (
          <section
            key={index}
            className="w-full grid grid-cols-3 text-xs font-bold border-x border-b border-light-text p-[5px]"
          >
            <p className="mb-0 text-start">{rule.level}</p>
            <p className="mb-0 text-start">
              {formatTurnoverForDisplay(i18next.language, rule?.from)}~
              {formatTurnoverForDisplay(i18next.language, rule?.to)}
            </p>
            <p className="mb-0 text-end">{rule.commission}</p>
          </section>
        );
      })}
    </section>
  );
};

export default RuleTable;
